<!-- SELECT2
https://select2.org/


EXEMPLO DE USO:

      <select2 v-model="nf.codnates"
          :options="{}"
          :value="nf.codnates"
          v-validate="{}"
          entity="nates/saida/outras"
          :minlength="0">
      </select2>


EXEMPLO FOCUS NO SELECT2:

this.$refs.part.$el.querySelector('select').focus()

-->

<template>
  <div class="w-100">
    <input-checkbox v-if="pesquisaItem" :estilo="'text-info'" label="Pesquisar por código" v-model="only_id" :value-checked="true" :value-unchecked="false"></input-checkbox>
    <select class="form-control" :tabindex="tabindex" :disabled="disabled" :placeholder="placeholder">
      <slot></slot>
    </select>
  </div>
</template>

<script>
import { SysVars } from '../main';
import { hasHiddenParent } from '../shared/utils';

export default {

    props: {
      options: {required: false},
      value: {required: false},
      entity: {type: String, default: '', required: false},
      url: {type: String, default: '', required: false},
      minlength: {type: Number, default: '', required: true},
      parent: {type: String, required: false},
      disabled: {type: Boolean, required: false},
      focus: {type: Boolean, default: false},
      tabindex: {type: Number},
      placeholder: {type: String},
    },

    data () {
      return {
        initOptions: this.options,
        only_id: false,
      }
    },

    computed: {
      pesquisaItem: function () {
        return this.entity == 'item'
      },

      cPlaceHolder: function () {
        if (this.placeholder)
          return this.placeholder
        else
          return 'Selecione'
      },
    },

    mounted () {
      var vm = this

      this.initSelect2()
      if (this.value == undefined) {
      } else {
        this.initValueSelect2()
      }

/* ATRIBUI VALORES VINDO DA PROP OPTIONS
      window.jQuery(this.$el).find('select')
        .empty().select2({ data: this.initOptions })
        .val(this.value)
*/

    },

    watch: {
      value: function (value) {
        // update value
        // console.log('value watch: ' + value)
        jQuery(this.$el).val(value)
        this.initValueSelect2()
      },

      focus: function (value) {
        if (value) this.$el.querySelector('select').focus()
      },

      /*
      options: function (options) {
        // update options
        jQuery(this.$el).empty().select2({ data: options })
      },
      */

    },

    created () {
        //console.log('value created: ' + this.value)
    },

    methods: {

      initValueSelect2 () {

        let vm = this
        if (this.value == '' || this.value == null) {
          //limpa o select2 quando receber um valor nulo
          jQuery(vm.$el).find('select').val('').trigger('change')
          return
        }


        jQuery.ajax({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ("Authorization", "Bearer " + vm.$store.getters.getEnv.token);
            xhr.setRequestHeader ("uuid", vm.$store.getters.getEnv.uuid);
          },
          delay: 300,
          url: vm.$store.getters.urlOrdsSelect + vm.entity + '/' + vm.value,
          dataType: 'json',
          data: function (params) {
            return ''
          },
          success: function (data) {
            if (data.items) {
              if (data.items.length == 0) {
                console.log(vm.entity + '/' + vm.value + ': código não encontrato')
              } else {
                var item = data.items[0]
                item.text = item.value
                
                var opt = new Option(item.value, item.id, true, true)
                var $select = jQuery(vm.$el).find('select')
                $select.append(opt)
                
                // attach the data to the option so select2 can see it
                $select.find('option[value="' + item.id + '"]').data('data', item)
                
                $select.trigger('change');
              }
            }
          },
        })

/*
        jQuery.getJSON(vm.$store.getters.urlOrdsSelect + this.entity + '/' + this.value, function(data) {
          if (data.items) {
            if (data.items.length == 0) {
              console.log(vm.entity + '/' + vm.value + ': código não encontrato')
            } else {
              vm.initOptions = {
                id: data.items[0].id,
                text: data.items[0].value
              }
              var opt = new Option(data.items[0].value, data.items[0].id, true, true)
              jQuery(vm.$el).find('select').append(opt).trigger('change');
            }
          }
        })
*/

      },

      initSelect2 () {
        //efetua a inicializacao do Select2
        var vm = this

        var obj = {
            minimumInputLength: vm.minlength,
            placeholder: this.cPlaceHolder,
            allowClear: true,
            theme: "bootstrap",

            language: {
              inputTooShort: function(args) {
                return "";
              },
              inputTooLong: function(args) {
                return "You typed too much";
              },
              errorLoading: function() {
                return "Erro ao carregar opções.";
              },
              loadingMore: function() {
                return "Carregando mais...";
              },
              noResults: function() {
                return "Nenhum resultado encontrado.";
              },
              searching: function() {
                return "Buscando...";
              },
              maximumSelected: function(args) {
                // args.maximum is the maximum number of items the user may select
                return "Erro ao carregar resultados";
              }
            },
            // language: "pt-BR",
            ajax: {
              beforeSend: function (xhr) {
                xhr.setRequestHeader ("Authorization", "Bearer " + vm.$store.getters.getEnv.token);
                xhr.setRequestHeader ("uuid", vm.$store.getters.getEnv.uuid);
              },
              delay: 300,
              url: function (params) {
                if (params.term) {
                  var str = params.term;
                  var term = params.term.toUpperCase();

                  // Se o termo parece um CNPJ formatado (contém simbolos e tem tamanho exato de 18 caracteres)
                  // removemos a formatação para a pesquisa ser efetiva no banco (alfanumérico puro)
                  if (term.length == 18 && (term.indexOf('.') >= 0 || term.indexOf('/') >= 0 || term.indexOf('-') >= 0)) {
                    term = term.replace(/[^A-Z0-9]/g, '');
                  }

                  // Normalizamos o termo de fallback (res) para também aceitar o novo formato alfanumérico
                  var res = term.replace(/[^A-Z0-9]/g, "");

                  if (vm.pesquisaItem)
                    if (vm.only_id){
                      return vm.$store.getters.urlOrdsSelect + vm.entity +
                        '/?q={"codigo":{"$or":[{"$eq":"' + term + '"}'+ (res?',{"codigo":{"$eq":"' + res.toUpperCase() + '"}}':'') + ']}}'
                    }else{
                      return vm.$store.getters.urlOrdsSelect + vm.entity +
                        '/?q={"descricao":{"$or":[{"$eq":"' + term + '"}' + (term.length > 3 ? ',{"$like":"%25' + term + '%25"}' : '') + ',{"codigo":{"$like":"%25' + term + '%25"}}'+ (res?',{"codigo":{"$eq":"' + res.toUpperCase() + '"}}':'') + ']}}'
                    }
                  else
                    return vm.$store.getters.urlOrdsSelect + vm.entity +
                      '/?q={"value":{"$or":[{"$like":"%25' + term + '%25"},{"id":{"$like":"%25' + term + '%25"}}'+ (res?',{"id":{"$like":"%25' + res.toUpperCase() + '%25"}}':'') + ']}}'

                } else {
                  return vm.$store.getters.urlOrdsSelect + vm.entity + '/'
                }
              },
              dataType: 'json',
              data: function (params) {
                return '' //retorna em branco para montagem dos parametros direto na url do ajax
              },
              processResults: function (data) {
                return {
                  results: jQuery.map(data.items, function (item) {
                      return {
                          text: item.value,
                          id: item.id,
                          class: item.class,
                          nome: item.nome,
                          fantasia: item.fantasia,
                          cnpjcpf: item.cnpjcpf,
                          codigo: item.codigo
                      }
                  })
                }
              },
            },
            templateResult: function (data) {
                if (data.nome) {
                   var $container = jQuery(
                     '<div class="select2-result-part">' +
                       '<div class="select2-result-part__nome" style="font-weight: bold; font-size: 1.1em;">' + data.nome + '</div>' +
                       '<div class="select2-result-part__fantasia" class="select2-result-part__fantasia" style="font-size: 0.9em;">' + (data.fantasia || '') + '</div>' +
                       '<div class="select2-result-part__info" class="select2-result-part__info" style="font-size: 0.8em;">' + 
                         (data.codigo ? 'Cod: ' + data.codigo : '') + 
                         (data.cnpjcpf ? ' - ' + data.cnpjcpf : '') + 
                       '</div>' +
                     '</div>'
                   );
                   return $container;
                }
                var $state = jQuery('<span class=select2-item-result "' + (data.class? data.class:'') + '">' + data.text + '</span>')
                return $state
            },
            templateSelection: function (data) {
                if (data.nome) {
                   return data.nome + ' (' + (data.fantasia || '') + ')';
                }
                return data.text;
            },
        }

        let dropdownParent = null;
        if (this.parent) {
          dropdownParent = window.jQuery('#' + this.parent);
        }
        
        if (!dropdownParent || dropdownParent.length === 0) {
          dropdownParent = jQuery(this.$el).parent();
        }

        Object.assign(obj, { dropdownParent: dropdownParent });

        jQuery(this.$el).find('select')    //https://select2.org/data-sources/ajax
          .select2(obj)
          .trigger('change')
          // emit event on change.
          .on('change', function () {
            if (this.value =='')
              vm.$emit('input', null);
            else
              vm.$emit('input', this.value);
          }).on('keyup', function (evt) {

          })

        jQuery(this.$el).on('keydown', '.select2-selection', function(e) {
          if (e.which === 13) {
            e.preventDefault();
            jQuery(vm.$el).find('select').select2('close')

            var thisIndex = jQuery(vm.$el.querySelector('select')).index(SysVars.sFocusControl)
            var next = thisIndex + 2
            var obj = jQuery(SysVars.sFocusControl)
            for (var x = next; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                return
              }
            }
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                return
              }
            }

          }
        })

      }


    },

    destroyed() {
      //console.log('select2 destroy:')
      //jQuery(this.$el).off().select2('destroy')
    }

}
</script>

<style scoped>
select {
  width: 100%;
}
</style>

<style>
/* Estilos para o resultado do select2 (dropdown) que não é afetado pelo scope do Vue */
.select2-result-part__fantasia {
  color: #555;
}

.select2-result-part__info {
  color: #888;
}

/* Quando o item está com foco (highlighted) no select2 */
.select2-results__option--highlighted .select2-result-part__fantasia,
.select2-results__option--highlighted .select2-result-part__info {
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/select2.vue